import React from 'react';

const Vue_Directives = () => {
  return (
    <div>
      <h1>Vue_Directives Component</h1>
      <p>This is the Vue_Directives tutorial page.</p>
    </div>
  );
}

export default Vue_Directives;
